import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { loggerId, type LoggerId } from './Logger.js'
import {
  loggerActivationId,
  type LoggerActivationId,
} from './LoggerActivation.js'
import {
  serviceContractItemId,
  type ServiceContractItemId,
} from './ServiceContractItem.js'
import { serviceItemId, type ServiceItemId } from './ServiceItem.js'
import { userId, type UserId } from './User.js'

/** Represents the view public.logger_activations_view_ */
export default interface LoggerActivationsViewTable {
  /** Database type: pg_catalog.int4 */
  loggerId: ColumnType<LoggerId, never, never>

  /** Database type: pg_catalog.text */
  loggerSerial: ColumnType<string, never, never>

  /** Database type: pg_catalog.uuid */
  loggerActivationId: ColumnType<LoggerActivationId, never, never>

  /** Database type: pg_catalog.uuid */
  serviceContractItemId: ColumnType<ServiceContractItemId | null, never, never>

  /** Database type: pg_catalog.uuid */
  serviceItemId: ColumnType<ServiceItemId | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  activatedAt: ColumnType<Date, never, never>

  /** Database type: pg_catalog.uuid */
  activatedBy: ColumnType<UserId | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  suspendedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.uuid */
  suspendedBy: ColumnType<UserId | null, never, never>

  /** Database type: pg_catalog.int4 */
  daysPurchased: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.numeric */
  daysConsumed: ColumnType<number, never, never>
}

export type LoggerActivationsView = Selectable<LoggerActivationsViewTable>

export const loggerActivationsView = z.object({
  loggerId: loggerId,
  loggerSerial: z.string(),
  loggerActivationId: loggerActivationId,
  serviceContractItemId: serviceContractItemId.nullable().optional(),
  serviceItemId: serviceItemId.nullable().optional(),
  activatedAt: z.coerce.date(),
  activatedBy: userId.nullable().optional(),
  suspendedAt: z.coerce.date().nullable().optional(),
  suspendedBy: userId.nullable().optional(),
  daysPurchased: z.number().nullable().optional(),
  daysConsumed: z.number(),
}) as unknown as z.Schema<LoggerActivationsView>
